export default "__VITE_ASSET__Bw__j1_z__ 584w";